import { library } from '@fortawesome/fontawesome-svg-core';

import { fasr } from '@fortawesome/sharp-regular-svg-icons';
import { fass } from '@fortawesome/sharp-solid-svg-icons';

export * from './constants';
export * from './components';
export * from './types';

library.add(fasr);
library.add(fass);
